import React from 'react';

const Gallery = ({ images }) => (
  <section id="gallery" className="py-16 text-center">
    <h2 className="text-3xl font-semibold text-purple-800 mb-8">Gallery</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 px-4 md:px-8 lg:px-16">
      {images.map((item, index) => (
        <div key={index} className="relative w-full">
          <img src={item.src} alt={`Gallery ${index + 1}`} className="rounded-lg w-full" />
          <span className="absolute bottom-2 right-2 bg-black bg-opacity-50 text-white text-xs px-2 py-1 rounded">
            {item.watermark}
          </span>
        </div>
      ))}
    </div>
  </section>
);

export default Gallery;